import { render, staticRenderFns } from "./UserBeta.vue?vue&type=template&id=5e343b94&scoped=true"
import script from "./UserBeta.vue?vue&type=script&lang=js"
export * from "./UserBeta.vue?vue&type=script&lang=js"
import style0 from "./UserBeta.vue?vue&type=style&index=0&id=5e343b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e343b94",
  null
  
)

export default component.exports